import { Fade, Menu, MenuItem } from "@material-ui/core";
import { IMenuListProps } from "../../../../../@types/components/MenuListProps";
import GetAppIcon from "@material-ui/icons/GetApp";
import ShareIcon from "@material-ui/icons/Share";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import downloadFile from "../../../../../utils/commonFunctions/downloadFile";
import ShareDocumentDialog from "../dialog/shareDocumentDialog/ShareDocumentDialog";
import { useState } from "react";
import DeleteDialog from "../dialog/deleteDialog/DeleteDialog";

const MenuList = ({
	anchorEl,
	handleClose,
	open,
	adminDocument,
	type,
	setDocumentList,
	documents,
	setAllDocumentList
}: IMenuListProps) => {
	const [shareDocumentDialog, setShareDocumentDialog] = useState<boolean>(false);
	const [deleteDocumentDialog, setDeleteDocumentDialog] = useState<boolean>(false);
	const [shareTo, setShareTo] = useState<"MEMBER" | "GROUP">("MEMBER");
	const handleChangeShareDialogOpenForMember = () => {
		setShareTo("MEMBER");
		setShareDocumentDialog(!shareDocumentDialog);
	};
	const handleChangeShareDialogOpenForGroup = () => {
		setShareTo("GROUP");
		setShareDocumentDialog(!shareDocumentDialog);
	};
	const handleDeleteDialogOpen = () => {
		setDeleteDocumentDialog(!deleteDocumentDialog);
	};

	const handleChangeShareDialogClose = () => {
		setShareDocumentDialog(!shareDocumentDialog);
	};
	return (
		<div>
			<Menu
				id="fade-menu"
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
				TransitionComponent={Fade}
			>
				<MenuItem
					onClick={handleChangeShareDialogOpenForMember}
					className="document-name-cell"
					style={{ paddingBottom: "10px" }}
				>
					<ShareIcon style={{ color: "#3A4652" }} />
					Share To Members
				</MenuItem>
				<MenuItem
					onClick={handleChangeShareDialogOpenForGroup}
					className="document-name-cell"
					style={{ paddingBottom: "10px" }}
				>
					<ShareIcon style={{ color: "#3A4652" }} />
					Share To Groups
				</MenuItem>
				{type === "file" ? (
					<MenuItem
						className="document-name-cell"
						style={{ paddingBottom: "10px" }}
						onClick={() => downloadFile(adminDocument.document_details.document)}
					>
						<GetAppIcon style={{ color: "#3A4652" }} />
						Download
					</MenuItem>
				) : null}
				<MenuItem
					className="document-name-cell"
					style={{ paddingBottom: "10px" }}
					onClick={handleDeleteDialogOpen}
				>
					<InfoOutlinedIcon style={{ color: "#3A4652" }} />
					info
				</MenuItem>
				<hr style={{ color: "##bdbbbb" }} />
				<MenuItem
					className="document-name-cell"
					style={{ paddingBottom: "10px" }}
					onClick={handleDeleteDialogOpen}
				>
					<DeleteIcon style={{ color: "#3A4652" }} />
					Delete
				</MenuItem>
			</Menu>
			<ShareDocumentDialog
				adminDocument={adminDocument}
				handleChangeShareDialogOpen={handleChangeShareDialogClose}
				open={shareDocumentDialog}
				key={0}
				shareTo={shareTo}
			/>
			<DeleteDialog
				documents={documents}
				open={deleteDocumentDialog}
				handleClose={handleDeleteDialogOpen}
				documentObectId={adminDocument._id}
				setDocumentList={setDocumentList}
				setAllDocumentList={setAllDocumentList}
			/>
		</div>
	);
};

export default MenuList;
